module.exports = __webpack_public_path__ + "img/1.ecc60df3.jpg";